import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`p-2 rounded-xl border transition-all duration-200 cursor-pointer flex items-center justify-center ${
        theme === 'light'
          ? 'bg-white border-slate-200 text-amber-500 hover:bg-slate-100 shadow-sm'
          : 'bg-slate-900 border-slate-700 text-yellow-400 hover:bg-slate-800 shadow-sm'
      } ${className}`}
      title={theme === 'light' ? 'Váltás Sötét Módra' : 'Váltás Világos Módra'}
      aria-label="Téma váltása"
    >
      {theme === 'light' ? (
        <Moon className="w-4 h-4 text-slate-700 hover:text-indigo-600 transition-colors" />
      ) : (
        <Sun className="w-4 h-4 text-amber-400 hover:rotate-45 transition-transform duration-300" />
      )}
    </button>
  );
};
